import { Link } from 'react-router-dom';
import { Sparkles, Megaphone, ArrowRight } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Alert } from '@/components/ui/Alert';
import { Button } from '@/components/ui/Button';

export function OwnerHomePage() {
  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="text-h1 text-text-primary mb-1">Owner Console</h1>
        <p className="text-small text-text-secondary">
          Platform-wide tools gated to the bot's owner set, never a per-guild permission.
        </p>
      </div>

      <Alert
        tone="warning"
        title="No real access control yet"
        description="This area will be gated by a live check against the bot's OWNER_IDS once auth ships (docs/ARCHITECTURE.md §3.4). Until then it is an unauthenticated preview of the eventual layout only."
      />

      <Card>
        <CardHeader
          title="Announcements"
          description="Auto-join welcome composer + broadcast send — the single most powerful action in the whole system."
        />
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-text-tertiary text-small">
            <Megaphone size={16} aria-hidden="true" />
            docs/IMPLEMENTATION_PLAN.md Feature 14, owner half
          </div>
          <Link to="/owner/announcements">
            <Button variant="secondary" size="sm">
              Open <ArrowRight size={14} aria-hidden="true" />
            </Button>
          </Link>
        </div>
      </Card>

      <Card>
        <CardHeader
          title="Dem AI Diagnostics"
          description="Provider health, benchmark leaderboard, cache, and platform-wide AI controls."
        />
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-text-tertiary text-small">
            <Sparkles size={16} aria-hidden="true" />
            docs/IMPLEMENTATION_PLAN.md Feature 26, owner half
          </div>
          <Link to="/owner/ai">
            <Button variant="secondary" size="sm">
              Open <ArrowRight size={14} aria-hidden="true" />
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
